// Pesos que se pueden pedir en las tarjetas de producto.
// 15 tons primero; 750 kg (0,75) y 500 kg (0,5) al final.

const PRODUCT_TONS_OPTIONS = [15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0.75, 0.5];
const HALF_TON = 0.5;
const THREE_QUARTER_TON = 0.75;
// Coincide con Product::PRESENTATION_FROM_TWO_TONS. No es un peso pedible.
const PRESENTATION_FROM_TWO_TONS = -1;
const MIN_FROM_TWO_TONS = 2;
const FRACTIONAL_BAGGED_PACKAGING = {
  [HALF_TON]: 'bagged25_05ton',
  [THREE_QUARTER_TON]: 'bagged25_075ton',
};

function normalizeTons(tons) {
  const number = Number(typeof tons === 'string' ? String(tons).replace(',', '.') : tons);
  if (!Number.isFinite(number)) return NaN;

  const match = PRODUCT_TONS_OPTIONS.find(option => Math.abs(option - number) < 0.001);
  if (match !== undefined) return match;

  return Math.round(number * 100) / 100;
}

function isSelectableProductTons(tons) {
  const normalized = normalizeTons(tons);

  return PRODUCT_TONS_OPTIONS.some(option => option === normalized);
}

function isFromTwoTonsPresentation(tons) {
  return normalizeTons(tons) === PRESENTATION_FROM_TWO_TONS;
}

function tonsOptionsForPresentation(presentationTons) {
  if (isFromTwoTonsPresentation(presentationTons)) {
    return PRODUCT_TONS_OPTIONS.filter(option => option >= MIN_FROM_TWO_TONS);
  }

  const normalized = normalizeTons(presentationTons);
  if (isSelectableProductTons(normalized)) return [normalized];

  return PRODUCT_TONS_OPTIONS.slice();
}

function formatProductTons(tons) {
  const normalized = normalizeTons(tons);
  if (!Number.isFinite(normalized)) return '';
  if (Number.isInteger(normalized)) return `${normalized} tons`;

  return `${String(normalized).replace('.', ',')} tons`;
}

function positiveTons(value, fallback) {
  const number = normalizeTons(value);
  if (Number.isFinite(number) && number > 0) return number;

  const fallbackNumber = Number(fallback);
  if (Number.isFinite(fallbackNumber) && fallbackNumber > 0) return fallbackNumber;

  return 15;
}

function parseProductTons(value) {
  if (typeof value === 'number') return normalizeTons(value);

  const match = String(value).trim().replace(',', '.').match(/(\d+(?:\.\d+)?)/);
  if (!match) return NaN;

  return normalizeTons(match[1]);
}

function baggedPackagingForTons(tons) {
  const normalized = normalizeTons(tons);
  if (FRACTIONAL_BAGGED_PACKAGING[normalized]) return FRACTIONAL_BAGGED_PACKAGING[normalized];

  return `bagged25_${normalized}ton`;
}

function baggedKilograms(packaging) {
  if (packaging === 'bagged25_05ton') return 500;
  if (packaging === 'bagged25_075ton') return 750;

  const tonMatch = packaging && String(packaging).match(/^bagged25_(\d+)ton$/);
  if (!tonMatch) return null;

  return parseInt(tonMatch[1], 10) * 1000;
}

module.exports = {
  PRODUCT_TONS_OPTIONS,
  HALF_TON,
  THREE_QUARTER_TON,
  PRESENTATION_FROM_TWO_TONS,
  MIN_FROM_TWO_TONS,
  normalizeTons,
  isSelectableProductTons,
  isFromTwoTonsPresentation,
  tonsOptionsForPresentation,
  formatProductTons,
  parseProductTons,
  positiveTons,
  baggedPackagingForTons,
  baggedKilograms,
};
